export default __webpack_public_path__ + "static/media/pharmatching-news-home.09c16e2e.webp";